
import { Checkbox, Modal, Row, Spin } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toggleSendDialog, sendNewsletter } from './newsletterActions';

class NewsletterSendModalComponent extends Component {

  state = {
    selectedDbs: new Set(),
    sendQ: false,
    sendJonas: false
  }

  onOk = () => {
    this.props.dispatch(sendNewsletter(
      this.props.newsletterId,
      Array.from(this.state.selectedDbs.values()),
      this.state.sendQ,
      this.state.sendJonas));

    this.setState({
      selectedDbs: new Set(),
      sendQ: false,
      sendJonas: false
    });
  }

  handleCancel = () => {
    this.setState({
      selectedDbs: new Set(),
      sendQ: false,
      sendJonas: false
    });

    this.props.dispatch(toggleSendDialog());
  }

  toggleDb(key) {

    if (this.state.selectedDbs.has(key)) {
      this.state.selectedDbs.delete(key);
    }
    else {
      this.state.selectedDbs.add(key);
    }

    this.setState({
      selectedDbs: this.state.selectedDbs
    });
  }

  toggleOther(key) {

    let state = this.state;

    state[key] = !state[key];
    this.setState(state);
  }

  render() {

    if (!this.props.showSendDialog) {
      return null;
    }

    return (

      <Modal
        title='Skicka nyhetsbrev'
        visible={true}
        width={1200}
        maskClosable={false}
        onOk={this.onOk}
        onCancel={this.handleCancel}
      >
        <Spin spinning={this.props.sendingEmail}>
          {this.props.allDatabases.map((d) => (
            <Row style={{ marginTop: 5 }}>
              <Checkbox checked={this.state.selectedDbs.has(d.key)} onChange={() => this.toggleDb(d.key)}>{d.name}</Checkbox>
            </Row>
          ))}

          <Row style={{ marginTop: 5 }}>
            <Checkbox checked={this.state.sendQ} onChange={() => this.toggleOther('sendQ')}>Test Utskick (Skickas till all med bokstaven Q i kundsystemet)</Checkbox>
          </Row>

          <Row style={{ marginTop: 5 }}>
            <Checkbox checked={this.state.sendJonas} onChange={() => this.toggleOther('sendJonas')}>Test Utskick till Jonas</Checkbox>
          </Row>
        </Spin>

      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    showSendDialog: state.newsletter.showSendDialog,
    newsletterId: state.newsletter.newsletterId,
    allDatabases: state.newsletter.allDatabases,
    sendingEmail: state.newsletter.sendingEmail
  }
};

export default connect(mapStateToProps)(NewsletterSendModalComponent);


// WEBPACK FOOTER //
// ./src/newsletter/newsletterSendModalComponent.js